/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Product_Classification_EditInputs */

const vi_product_classification_edit = /** @type {(inputs: Product_Classification_EditInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sửa phân loại`)
};

/**

* @param {Product_Classification_EditInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const product_classification_edit = /** @type {((inputs?: Product_Classification_EditInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Product_Classification_EditInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_product_classification_edit(inputs)
});